import React, { Suspense, StrictMode } from "react";
import ReactDOM from "react-dom";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import CustomRouter from "./components/customRouter/CustomRouter";
import { Provider as ReduxProvider } from "react-redux";
import { AuthProvider } from "./contexts/authContext/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { StyledEngineProvider } from "@mui/material/styles";
import SplashScreen from "./components/splashScreen/SplashScreen";
import configureStore from "./redux/store/configureStore";
import "./clipboardConfig";
import { history } from "./history";
import KeycloakSwitch from "./channel/KeycloakSwitch";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import { growthbook, genericConfig } from "./config";
import { Web3ReactProvider } from "@web3-react/core";
import { getLibrary } from "smartcontract/utils/connector";

const store = configureStore();

if (genericConfig.SENTRY_DSN) {
  Sentry.init({
    dsn: "https://62649b2c81bd476eb9763bb15903e452@o1280396.ingest.sentry.io/6483576",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

Sentry.captureMessage("version debugTrueID");

ReactDOM.render(
  <StrictMode>
    <GrowthBookProvider growthbook={growthbook}>
      <KeycloakSwitch>
        <Suspense fallback={<SplashScreen />}>
          <HelmetProvider>
            <Web3ReactProvider getLibrary={getLibrary}>
              <ReduxProvider store={store}>
                <StyledEngineProvider injectFirst>
                  <SettingsProvider>
                    <CustomRouter history={history}>
                      <AuthProvider>
                        <App />
                      </AuthProvider>
                    </CustomRouter>
                  </SettingsProvider>
                </StyledEngineProvider>
              </ReduxProvider>
            </Web3ReactProvider>
          </HelmetProvider>
        </Suspense>
      </KeycloakSwitch>
    </GrowthBookProvider>
  </StrictMode>,
  document.getElementById("root"),
);
